import React, { Component } from 'react'
// import moment from 'moment'
import { translation } from '../../../utils/helpers'
import { getWeekDay, renderFullDate } from '../../../utils/time'

import { ElementIcons } from '../../../shared/elements/icons'
import TimeLineSegment from '../../../shared/elements/timeLineSegment'
import Icon from '../../../shared/elements/icon'
import Chevron from '../../../shared/elements/chevron'
import Grid from '../../../shared/elements/grid'

const LINE_TYPES = {
  None: -1,
  DoubleSolid: 0,
  DoubleDashed: 1,
  SingleSolid: 2,
  SingleDashed: 3
}

const POINT_TYPES = {
  None: -1,
  Default: 0,
  Dot_Gray: 1,
  Intersection: 2,
  Ok_Green: 3,
  Exclamation_Red: 4
}

// const formatDate = (date) => {
//   return moment(date).format('DD-MM-YYYY hh:mm')
// }

class StepsArea extends Component {
  constructor (props) {
    super(props)

    this.state = {
      stepsExpanded: false
    }
    this.renderStep = this.renderStep.bind(this)
    this.renderUnfinishedProcessStep = this.renderUnfinishedProcessStep.bind(this)
  }

  renderUnfinishedProcessStep (step, index) {
    let contentClass = 'content'
    if (!step.IsActive) contentClass += ' dimmed'

    let lines = [{
      LineTypeBefore: LINE_TYPES.DoubleDashed,
      LineDotType: step.IsCompleted ? POINT_TYPES.Ok_Green : POINT_TYPES.Dot_Gray,
      LineTypeAfter: LINE_TYPES.DoubleDashed
    }]

    if (!this.state.stepsExpanded && step.IsCompleted && !step.IsActive) return null
    let isBodyShopFinishing = step.OrderBy !== 9
    return (
      <div key={`un-item-${index}-container`} className={isBodyShopFinishing ? 'wrap-unfinished-process-step' : null} >
        <div key={`un-item-${index}`} className={'timeline-step'}>
          <div className='lines'>
            <TimeLineSegment lines={lines} active={step.IsActive === true} topHeight='4px' bottomHeight='1fr' />
          </div>
          <div className={contentClass}>
            <div className='top h2-fz h2-color'>
              <Grid cols={['auto', '24px']}>
                <div>{translation(step.DictionaryKey)}</div>
                {step.IsActive && <Chevron open={this.state.stepsExpanded} onClick={() => { this.setState({ stepsExpanded: !this.state.stepsExpanded }) }} />}
              </Grid>
            </div>
            <div className='bottom'>
              <Grid cols={['24px', 'auto']}>
                {!isBodyShopFinishing ? <Icon icon={ElementIcons.Indent} /> : null}
                <div>
                  {!isBodyShopFinishing ? <time>{getWeekDay(step.Date)}, {renderFullDate(step.Date)}</time> : null}
                  {step.AdditionalText && <span>{step.AdditionalText}</span>}
                </div>
              </Grid>
            </div>
          </div>
        </div>
      </div>
    )
  }
  // step active
  renderStep (step, index) {
    let contentClass = 'content'
    if (!step.IsActive) contentClass += ' dimmed'

    let lines = [{
      LineTypeBefore: LINE_TYPES.DoubleDashed,
      LineDotType: step.IsCompleted ? POINT_TYPES.Ok_Green : POINT_TYPES.Dot_Gray,
      LineTypeAfter: LINE_TYPES.DoubleDashed
    }]

    if (!this.state.stepsExpanded && step.IsCompleted && !step.IsActive) return null

    return (
      <div key={`item-${index}`} className='timeline-step'>
        <div className='lines'>
          <TimeLineSegment lines={lines} active={step.IsActive === true} topHeight='4px' bottomHeight='1fr' />
        </div>
        <div className={contentClass}>
          <div className='top h2-fz h2-color'>
            <Grid cols={['auto', '24px']}>
              <div>{translation(step.DictionaryKey)}</div>
              {step.IsActive && <Chevron isOpenUp={this.state.stepsExpanded} open={this.state.stepsExpanded} onClick={() => { this.setState({ stepsExpanded: !this.state.stepsExpanded }) }} />}
            </Grid>
          </div>
          <div className='bottom'>
            <Grid cols={['24px', 'auto']}>
              <Icon icon={ElementIcons.Indent} />
              <div>
                <time>{getWeekDay(step.Date)}, {renderFullDate(step.Date)}</time>
                {step.AdditionalText && <span>{step.AdditionalText}</span>}
              </div>
            </Grid>
          </div>
        </div>
      </div>
    )
  }

  render () {
    if (this.props.timeLine === null) return null
    return (
      <div className='steps steps-wrap'>
        <div className={this.state.stepsExpanded ? 'steps--show' : ''}>
          {this.props.timeLine.UnfinishedProcessSteps.map(this.renderUnfinishedProcessStep)}
          {this.props.timeLine.Steps.map(this.renderStep)}
        </div>
      </div>
    )
  }
}

export default StepsArea



// WEBPACK FOOTER //
// ./src/app/pages/CarOwnerPortal/components/stepsArea.js